"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _IdeationListItem = _interopRequireDefault(require("./IdeationListItem"));

var IdeationList = function IdeationList(props) {
  return (0, _preact.h)("table", {
    className: "ideation-list_table table table-bordered"
  }, (0, _preact.h)("thead", {
    className: "ideation-list__table-header"
  }, (0, _preact.h)("tr", null, (0, _preact.h)("th", null, " Status "), (0, _preact.h)("th", null, " Background Color "), (0, _preact.h)("th", null, " Text Color "), (0, _preact.h)("th", null, " Actions "))), (0, _preact.h)("tbody", null, props.list.map(function (item, idx) {
    return (0, _preact.h)(_IdeationListItem.default, {
      deleteCallback: props.deleteCallback,
      openEditIdeationModal: props.openEditIdeationModal,
      item: item,
      idx: idx,
      colors: props.colors
    });
  })));
};

var _default = IdeationList;
exports.default = _default;